"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StoryType = exports.PlayerStory = exports.PlayerSnapMediaType = exports.PlayerSnapMedia = exports.PlayerSnap = void 0;
exports.playerSnapMediaTypeFromJSON = playerSnapMediaTypeFromJSON;
exports.playerSnapMediaTypeToJSON = playerSnapMediaTypeToJSON;
exports.protobufPackage = void 0;
exports.storyTypeFromJSON = storyTypeFromJSON;
exports.storyTypeToJSON = storyTypeToJSON;

var _long2 = _interopRequireDefault(require("long"));

var _minimal = _interopRequireDefault(require("protobufjs/minimal"));

var _wrappers = require("./wrappers");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var protobufPackage = "snapchat.web.stories";
/**
 * Story type. Given a fetch_id in StoryFetchRequest, determine its StoryType
 * either by fetching an entry from the spanner or by parsing the prefix of
 * the fetch_id.
 */

exports.protobufPackage = protobufPackage;
var StoryType;
exports.StoryType = StoryType;

(function (StoryType) {
  StoryType[StoryType["TYPE_UNKNOWN"] = 0] = "TYPE_UNKNOWN";
  StoryType[StoryType["TYPE_FEATURED"] = 2] = "TYPE_FEATURED";
  StoryType[StoryType["TYPE_DISCOVER"] = 3] = "TYPE_DISCOVER";
  StoryType[StoryType["TYPE_PUBLIC_USER_SNAP"] = 6] = "TYPE_PUBLIC_USER_SNAP";
  StoryType[StoryType["TYPE_DYNAMIC"] = 1] = "TYPE_DYNAMIC";
  StoryType[StoryType["TYPE_STORY_FEED"] = 7] = "TYPE_STORY_FEED";
  StoryType[StoryType["TYPE_PUBLIC_USER_STORY"] = 5] = "TYPE_PUBLIC_USER_STORY";
  StoryType[StoryType["TYPE_LIVE_STREAM"] = 10] = "TYPE_LIVE_STREAM";
  StoryType[StoryType["TYPE_STORY_ID"] = 12] = "TYPE_STORY_ID";
  StoryType[StoryType["TYPE_MAPS"] = 4] = "TYPE_MAPS";
  StoryType[StoryType["TYPE_LENS_STORY"] = 14] = "TYPE_LENS_STORY";
  StoryType[StoryType["TYPE_SHARED_SINGLE_SNAP"] = 9] = "TYPE_SHARED_SINGLE_SNAP";
  StoryType[StoryType["TYPE_MAPS_SINGLE_SNAP"] = 8] = "TYPE_MAPS_SINGLE_SNAP";
  StoryType[StoryType["TYPE_PUBLIC_MY_STORY_SNAP"] = 13] = "TYPE_PUBLIC_MY_STORY_SNAP";
  StoryType[StoryType["TYPE_SHARED_OUR_STORY_SNAP"] = 11] = "TYPE_SHARED_OUR_STORY_SNAP";
  StoryType[StoryType["TYPE_COMMUNITY"] = 15] = "TYPE_COMMUNITY";
  StoryType[StoryType["PUBLISHER"] = 16] = "PUBLISHER";
  StoryType[StoryType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(StoryType || (exports.StoryType = StoryType = {}));

function storyTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "TYPE_UNKNOWN":
      return StoryType.TYPE_UNKNOWN;

    case 2:
    case "TYPE_FEATURED":
      return StoryType.TYPE_FEATURED;

    case 3:
    case "TYPE_DISCOVER":
      return StoryType.TYPE_DISCOVER;

    case 6:
    case "TYPE_PUBLIC_USER_SNAP":
      return StoryType.TYPE_PUBLIC_USER_SNAP;

    case 1:
    case "TYPE_DYNAMIC":
      return StoryType.TYPE_DYNAMIC;

    case 7:
    case "TYPE_STORY_FEED":
      return StoryType.TYPE_STORY_FEED;

    case 5:
    case "TYPE_PUBLIC_USER_STORY":
      return StoryType.TYPE_PUBLIC_USER_STORY;

    case 10:
    case "TYPE_LIVE_STREAM":
      return StoryType.TYPE_LIVE_STREAM;

    case 12:
    case "TYPE_STORY_ID":
      return StoryType.TYPE_STORY_ID;

    case 4:
    case "TYPE_MAPS":
      return StoryType.TYPE_MAPS;

    case 14:
    case "TYPE_LENS_STORY":
      return StoryType.TYPE_LENS_STORY;

    case 9:
    case "TYPE_SHARED_SINGLE_SNAP":
      return StoryType.TYPE_SHARED_SINGLE_SNAP;

    case 8:
    case "TYPE_MAPS_SINGLE_SNAP":
      return StoryType.TYPE_MAPS_SINGLE_SNAP;

    case 13:
    case "TYPE_PUBLIC_MY_STORY_SNAP":
      return StoryType.TYPE_PUBLIC_MY_STORY_SNAP;

    case 11:
    case "TYPE_SHARED_OUR_STORY_SNAP":
      return StoryType.TYPE_SHARED_OUR_STORY_SNAP;

    case 15:
    case "TYPE_COMMUNITY":
      return StoryType.TYPE_COMMUNITY;

    case 16:
    case "PUBLISHER":
      return StoryType.PUBLISHER;

    case -1:
    case "UNRECOGNIZED":
    default:
      return StoryType.UNRECOGNIZED;
  }
}

function storyTypeToJSON(object) {
  switch (object) {
    case StoryType.TYPE_UNKNOWN:
      return "TYPE_UNKNOWN";

    case StoryType.TYPE_FEATURED:
      return "TYPE_FEATURED";

    case StoryType.TYPE_DISCOVER:
      return "TYPE_DISCOVER";

    case StoryType.TYPE_PUBLIC_USER_SNAP:
      return "TYPE_PUBLIC_USER_SNAP";

    case StoryType.TYPE_DYNAMIC:
      return "TYPE_DYNAMIC";

    case StoryType.TYPE_STORY_FEED:
      return "TYPE_STORY_FEED";

    case StoryType.TYPE_PUBLIC_USER_STORY:
      return "TYPE_PUBLIC_USER_STORY";

    case StoryType.TYPE_LIVE_STREAM:
      return "TYPE_LIVE_STREAM";

    case StoryType.TYPE_STORY_ID:
      return "TYPE_STORY_ID";

    case StoryType.TYPE_MAPS:
      return "TYPE_MAPS";

    case StoryType.TYPE_LENS_STORY:
      return "TYPE_LENS_STORY";

    case StoryType.TYPE_SHARED_SINGLE_SNAP:
      return "TYPE_SHARED_SINGLE_SNAP";

    case StoryType.TYPE_MAPS_SINGLE_SNAP:
      return "TYPE_MAPS_SINGLE_SNAP";

    case StoryType.TYPE_PUBLIC_MY_STORY_SNAP:
      return "TYPE_PUBLIC_MY_STORY_SNAP";

    case StoryType.TYPE_SHARED_OUR_STORY_SNAP:
      return "TYPE_SHARED_OUR_STORY_SNAP";

    case StoryType.TYPE_COMMUNITY:
      return "TYPE_COMMUNITY";

    case StoryType.PUBLISHER:
      return "PUBLISHER";

    case StoryType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

var PlayerSnapMediaType;
exports.PlayerSnapMediaType = PlayerSnapMediaType;

(function (PlayerSnapMediaType) {
  PlayerSnapMediaType[PlayerSnapMediaType["IMAGE"] = 0] = "IMAGE";
  PlayerSnapMediaType[PlayerSnapMediaType["VIDEO"] = 1] = "VIDEO";
  PlayerSnapMediaType[PlayerSnapMediaType["VIDEO_NO_SOUND"] = 2] = "VIDEO_NO_SOUND";
  PlayerSnapMediaType[PlayerSnapMediaType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PlayerSnapMediaType || (exports.PlayerSnapMediaType = PlayerSnapMediaType = {}));

function playerSnapMediaTypeFromJSON(object) {
  switch (object) {
    case 0:
    case "IMAGE":
      return PlayerSnapMediaType.IMAGE;

    case 1:
    case "VIDEO":
      return PlayerSnapMediaType.VIDEO;

    case 2:
    case "VIDEO_NO_SOUND":
      return PlayerSnapMediaType.VIDEO_NO_SOUND;

    case -1:
    case "UNRECOGNIZED":
    default:
      return PlayerSnapMediaType.UNRECOGNIZED;
  }
}

function playerSnapMediaTypeToJSON(object) {
  switch (object) {
    case PlayerSnapMediaType.IMAGE:
      return "IMAGE";

    case PlayerSnapMediaType.VIDEO:
      return "VIDEO";

    case PlayerSnapMediaType.VIDEO_NO_SOUND:
      return "VIDEO_NO_SOUND";

    case PlayerSnapMediaType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBasePlayerSnapMedia() {
  return {
    mediaUrl: "",
    mediaPreviewUrl: undefined,
    overlayUrl: undefined,
    attachmentUrl: undefined
  };
}

var PlayerSnapMedia = {
  encode: function encode(message) {
    var writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _minimal["default"].Writer.create();

    if (message.mediaUrl !== "") {
      writer.uint32(10).string(message.mediaUrl);
    }

    if (message.mediaPreviewUrl !== undefined) {
      _wrappers.StringWrapper.encode(message.mediaPreviewUrl, writer.uint32(18).fork()).ldelim();
    }

    if (message.overlayUrl !== undefined) {
      _wrappers.StringWrapper.encode(message.overlayUrl, writer.uint32(26).fork()).ldelim();
    }

    if (message.attachmentUrl !== undefined) {
      _wrappers.StringWrapper.encode(message.attachmentUrl, writer.uint32(34).fork()).ldelim();
    }

    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _minimal["default"].Reader ? input : new _minimal["default"].Reader(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBasePlayerSnapMedia();

    while (reader.pos < end) {
      var tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.mediaUrl = reader.string();
          break;

        case 2:
          message.mediaPreviewUrl = _wrappers.StringWrapper.decode(reader, reader.uint32());
          break;

        case 3:
          message.overlayUrl = _wrappers.StringWrapper.decode(reader, reader.uint32());
          break;

        case 4:
          message.attachmentUrl = _wrappers.StringWrapper.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      mediaUrl: isSet(object.mediaUrl) ? String(object.mediaUrl) : "",
      mediaPreviewUrl: isSet(object.mediaPreviewUrl) ? _wrappers.StringWrapper.fromJSON(object.mediaPreviewUrl) : undefined,
      overlayUrl: isSet(object.overlayUrl) ? _wrappers.StringWrapper.fromJSON(object.overlayUrl) : undefined,
      attachmentUrl: isSet(object.attachmentUrl) ? _wrappers.StringWrapper.fromJSON(object.attachmentUrl) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    message.mediaUrl !== undefined && (obj.mediaUrl = message.mediaUrl);
    message.mediaPreviewUrl !== undefined && (obj.mediaPreviewUrl = message.mediaPreviewUrl ? _wrappers.StringWrapper.toJSON(message.mediaPreviewUrl) : undefined);
    message.overlayUrl !== undefined && (obj.overlayUrl = message.overlayUrl ? _wrappers.StringWrapper.toJSON(message.overlayUrl) : undefined);
    message.attachmentUrl !== undefined && (obj.attachmentUrl = message.attachmentUrl ? _wrappers.StringWrapper.toJSON(message.attachmentUrl) : undefined);
    return obj;
  },
  fromPartial: function fromPartial(object) {
    var _object$mediaUrl;

    var message = createBasePlayerSnapMedia();
    message.mediaUrl = (_object$mediaUrl = object.mediaUrl) !== null && _object$mediaUrl !== void 0 ? _object$mediaUrl : "";
    message.mediaPreviewUrl = object.mediaPreviewUrl !== undefined && object.mediaPreviewUrl !== null ? _wrappers.StringWrapper.fromPartial(object.mediaPreviewUrl) : undefined;
    message.overlayUrl = object.overlayUrl !== undefined && object.overlayUrl !== null ? _wrappers.StringWrapper.fromPartial(object.overlayUrl) : undefined;
    message.attachmentUrl = object.attachmentUrl !== undefined && object.attachmentUrl !== null ? _wrappers.StringWrapper.fromPartial(object.attachmentUrl) : undefined;
    return message;
  }
};
exports.PlayerSnapMedia = PlayerSnapMedia;

function createBasePlayerSnap() {
  return {
    snapIndex: 0,
    snapId: undefined,
    snapMediaType: 0,
    snapUrls: undefined,
    isSponsored: undefined,
    timestampInSec: undefined,
    snapTitle: undefined,
    snapSubtitles: undefined,
    lat: undefined,
    lng: undefined,
    hasAttachment: undefined
  };
}

var PlayerSnap = {
  encode: function encode(message) {
    var writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _minimal["default"].Writer.create();

    if (message.snapIndex !== 0) {
      writer.uint32(8).int32(message.snapIndex);
    }

    if (message.snapId !== undefined) {
      _wrappers.StringWrapper.encode(message.snapId, writer.uint32(18).fork()).ldelim();
    }

    if (message.snapMediaType !== 0) {
      writer.uint32(24).int32(message.snapMediaType);
    }

    if (message.snapUrls !== undefined) {
      PlayerSnapMedia.encode(message.snapUrls, writer.uint32(34).fork()).ldelim();
    }

    if (message.isSponsored !== undefined) {
      _wrappers.BoolWrapper.encode(message.isSponsored, writer.uint32(42).fork()).ldelim();
    }

    if (message.timestampInSec !== undefined) {
      _wrappers.Int64Wrapper.encode(message.timestampInSec, writer.uint32(50).fork()).ldelim();
    }

    if (message.snapTitle !== undefined) {
      _wrappers.StringWrapper.encode(message.snapTitle, writer.uint32(58).fork()).ldelim();
    }

    if (message.snapSubtitles !== undefined) {
      _wrappers.StringWrapper.encode(message.snapSubtitles, writer.uint32(66).fork()).ldelim();
    }

    if (message.lat !== undefined) {
      _wrappers.DoubleWrapper.encode(message.lat, writer.uint32(74).fork()).ldelim();
    }

    if (message.lng !== undefined) {
      _wrappers.DoubleWrapper.encode(message.lng, writer.uint32(82).fork()).ldelim();
    }

    if (message.hasAttachment !== undefined) {
      _wrappers.BoolWrapper.encode(message.hasAttachment, writer.uint32(90).fork()).ldelim();
    }

    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _minimal["default"].Reader ? input : new _minimal["default"].Reader(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBasePlayerSnap();

    while (reader.pos < end) {
      var tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.snapIndex = reader.int32();
          break;

        case 2:
          message.snapId = _wrappers.StringWrapper.decode(reader, reader.uint32());
          break;

        case 3:
          message.snapMediaType = reader.int32();
          break;

        case 4:
          message.snapUrls = PlayerSnapMedia.decode(reader, reader.uint32());
          break;

        case 5:
          message.isSponsored = _wrappers.BoolWrapper.decode(reader, reader.uint32());
          break;

        case 6:
          message.timestampInSec = _wrappers.Int64Wrapper.decode(reader, reader.uint32());
          break;

        case 7:
          message.snapTitle = _wrappers.StringWrapper.decode(reader, reader.uint32());
          break;

        case 8:
          message.snapSubtitles = _wrappers.StringWrapper.decode(reader, reader.uint32());
          break;

        case 9:
          message.lat = _wrappers.DoubleWrapper.decode(reader, reader.uint32());
          break;

        case 10:
          message.lng = _wrappers.DoubleWrapper.decode(reader, reader.uint32());
          break;

        case 11:
          message.hasAttachment = _wrappers.BoolWrapper.decode(reader, reader.uint32());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      snapIndex: isSet(object.snapIndex) ? Number(object.snapIndex) : 0,
      snapId: isSet(object.snapId) ? _wrappers.StringWrapper.fromJSON(object.snapId) : undefined,
      snapMediaType: isSet(object.snapMediaType) ? playerSnapMediaTypeFromJSON(object.snapMediaType) : 0,
      snapUrls: isSet(object.snapUrls) ? PlayerSnapMedia.fromJSON(object.snapUrls) : undefined,
      isSponsored: isSet(object.isSponsored) ? _wrappers.BoolWrapper.fromJSON(object.isSponsored) : undefined,
      timestampInSec: isSet(object.timestampInSec) ? _wrappers.Int64Wrapper.fromJSON(object.timestampInSec) : undefined,
      snapTitle: isSet(object.snapTitle) ? _wrappers.StringWrapper.fromJSON(object.snapTitle) : undefined,
      snapSubtitles: isSet(object.snapSubtitles) ? _wrappers.StringWrapper.fromJSON(object.snapSubtitles) : undefined,
      lat: isSet(object.lat) ? _wrappers.DoubleWrapper.fromJSON(object.lat) : undefined,
      lng: isSet(object.lng) ? _wrappers.DoubleWrapper.fromJSON(object.lng) : undefined,
      hasAttachment: isSet(object.hasAttachment) ? _wrappers.BoolWrapper.fromJSON(object.hasAttachment) : undefined
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    message.snapIndex !== undefined && (obj.snapIndex = Math.round(message.snapIndex));
    message.snapId !== undefined && (obj.snapId = message.snapId ? _wrappers.StringWrapper.toJSON(message.snapId) : undefined);
    message.snapMediaType !== undefined && (obj.snapMediaType = playerSnapMediaTypeToJSON(message.snapMediaType));
    message.snapUrls !== undefined && (obj.snapUrls = message.snapUrls ? PlayerSnapMedia.toJSON(message.snapUrls) : undefined);
    message.isSponsored !== undefined && (obj.isSponsored = message.isSponsored ? _wrappers.BoolWrapper.toJSON(message.isSponsored) : undefined);
    message.timestampInSec !== undefined && (obj.timestampInSec = message.timestampInSec ? _wrappers.Int64Wrapper.toJSON(message.timestampInSec) : undefined);
    message.snapTitle !== undefined && (obj.snapTitle = message.snapTitle ? _wrappers.StringWrapper.toJSON(message.snapTitle) : undefined);
    message.snapSubtitles !== undefined && (obj.snapSubtitles = message.snapSubtitles ? _wrappers.StringWrapper.toJSON(message.snapSubtitles) : undefined);
    message.lat !== undefined && (obj.lat = message.lat ? _wrappers.DoubleWrapper.toJSON(message.lat) : undefined);
    message.lng !== undefined && (obj.lng = message.lng ? _wrappers.DoubleWrapper.toJSON(message.lng) : undefined);
    message.hasAttachment !== undefined && (obj.hasAttachment = message.hasAttachment ? _wrappers.BoolWrapper.toJSON(message.hasAttachment) : undefined);
    return obj;
  },
  fromPartial: function fromPartial(object) {
    var _object$snapIndex, _object$snapMediaType;

    var message = createBasePlayerSnap();
    message.snapIndex = (_object$snapIndex = object.snapIndex) !== null && _object$snapIndex !== void 0 ? _object$snapIndex : 0;
    message.snapId = object.snapId !== undefined && object.snapId !== null ? _wrappers.StringWrapper.fromPartial(object.snapId) : undefined;
    message.snapMediaType = (_object$snapMediaType = object.snapMediaType) !== null && _object$snapMediaType !== void 0 ? _object$snapMediaType : 0;
    message.snapUrls = object.snapUrls !== undefined && object.snapUrls !== null ? PlayerSnapMedia.fromPartial(object.snapUrls) : undefined;
    message.isSponsored = object.isSponsored !== undefined && object.isSponsored !== null ? _wrappers.BoolWrapper.fromPartial(object.isSponsored) : undefined;
    message.timestampInSec = object.timestampInSec !== undefined && object.timestampInSec !== null ? _wrappers.Int64Wrapper.fromPartial(object.timestampInSec) : undefined;
    message.snapTitle = object.snapTitle !== undefined && object.snapTitle !== null ? _wrappers.StringWrapper.fromPartial(object.snapTitle) : undefined;
    message.snapSubtitles = object.snapSubtitles !== undefined && object.snapSubtitles !== null ? _wrappers.StringWrapper.fromPartial(object.snapSubtitles) : undefined;
    message.lat = object.lat !== undefined && object.lat !== null ? _wrappers.DoubleWrapper.fromPartial(object.lat) : undefined;
    message.lng = object.lng !== undefined && object.lng !== null ? _wrappers.DoubleWrapper.fromPartial(object.lng) : undefined;
    message.hasAttachment = object.hasAttachment !== undefined && object.hasAttachment !== null ? _wrappers.BoolWrapper.fromPartial(object.hasAttachment) : undefined;
    return message;
  }
};
exports.PlayerSnap = PlayerSnap;

function createBasePlayerStory() {
  return {
    storyType: 0,
    snapList: [],
    storyId: undefined,
    storyTitle: undefined,
    thumbnailUrl: undefined,
    storySubtitle: undefined,
    storyShareId: undefined,
    canonicalUrlSuffix: undefined,
    emoji: undefined,
    storyTapId: "0"
  };
}

var PlayerStory = {
  encode: function encode(message) {
    var writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _minimal["default"].Writer.create();

    if (message.storyType !== 0) {
      writer.uint32(8).int32(message.storyType);
    }

    var _iterator = _createForOfIteratorHelper(message.snapList),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var v = _step.value;
        PlayerSnap.encode(v, writer.uint32(18).fork()).ldelim();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    if (message.storyId !== undefined) {
      _wrappers.StringWrapper.encode(message.storyId, writer.uint32(26).fork()).ldelim();
    }

    if (message.storyTitle !== undefined) {
      _wrappers.StringWrapper.encode(message.storyTitle, writer.uint32(34).fork()).ldelim();
    }

    if (message.thumbnailUrl !== undefined) {
      _wrappers.StringWrapper.encode(message.thumbnailUrl, writer.uint32(42).fork()).ldelim();
    }

    if (message.storySubtitle !== undefined) {
      _wrappers.StringWrapper.encode(message.storySubtitle, writer.uint32(50).fork()).ldelim();
    }

    if (message.storyShareId !== undefined) {
      _wrappers.StringWrapper.encode(message.storyShareId, writer.uint32(58).fork()).ldelim();
    }

    if (message.canonicalUrlSuffix !== undefined) {
      _wrappers.StringWrapper.encode(message.canonicalUrlSuffix, writer.uint32(66).fork()).ldelim();
    }

    if (message.emoji !== undefined) {
      _wrappers.StringWrapper.encode(message.emoji, writer.uint32(74).fork()).ldelim();
    }

    if (message.storyTapId !== "0") {
      writer.uint32(80).sint64(message.storyTapId);
    }

    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _minimal["default"].Reader ? input : new _minimal["default"].Reader(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBasePlayerStory();

    while (reader.pos < end) {
      var tag = reader.uint32();

      switch (tag >>> 3) {
        case 1:
          message.storyType = reader.int32();
          break;

        case 2:
          message.snapList.push(PlayerSnap.decode(reader, reader.uint32()));
          break;

        case 3:
          message.storyId = _wrappers.StringWrapper.decode(reader, reader.uint32());
          break;

        case 4:
          message.storyTitle = _wrappers.StringWrapper.decode(reader, reader.uint32());
          break;

        case 5:
          message.thumbnailUrl = _wrappers.StringWrapper.decode(reader, reader.uint32());
          break;

        case 6:
          message.storySubtitle = _wrappers.StringWrapper.decode(reader, reader.uint32());
          break;

        case 7:
          message.storyShareId = _wrappers.StringWrapper.decode(reader, reader.uint32());
          break;

        case 8:
          message.canonicalUrlSuffix = _wrappers.StringWrapper.decode(reader, reader.uint32());
          break;

        case 9:
          message.emoji = _wrappers.StringWrapper.decode(reader, reader.uint32());
          break;

        case 10:
          message.storyTapId = longToString(reader.sint64());
          break;

        default:
          reader.skipType(tag & 7);
          break;
      }
    }

    return message;
  },
  fromJSON: function fromJSON(object) {
    return {
      storyType: isSet(object.storyType) ? storyTypeFromJSON(object.storyType) : 0,
      snapList: Array.isArray(object === null || object === void 0 ? void 0 : object.snapList) ? object.snapList.map(function (e) {
        return PlayerSnap.fromJSON(e);
      }) : [],
      storyId: isSet(object.storyId) ? _wrappers.StringWrapper.fromJSON(object.storyId) : undefined,
      storyTitle: isSet(object.storyTitle) ? _wrappers.StringWrapper.fromJSON(object.storyTitle) : undefined,
      thumbnailUrl: isSet(object.thumbnailUrl) ? _wrappers.StringWrapper.fromJSON(object.thumbnailUrl) : undefined,
      storySubtitle: isSet(object.storySubtitle) ? _wrappers.StringWrapper.fromJSON(object.storySubtitle) : undefined,
      storyShareId: isSet(object.storyShareId) ? _wrappers.StringWrapper.fromJSON(object.storyShareId) : undefined,
      canonicalUrlSuffix: isSet(object.canonicalUrlSuffix) ? _wrappers.StringWrapper.fromJSON(object.canonicalUrlSuffix) : undefined,
      emoji: isSet(object.emoji) ? _wrappers.StringWrapper.fromJSON(object.emoji) : undefined,
      storyTapId: isSet(object.storyTapId) ? String(object.storyTapId) : "0"
    };
  },
  toJSON: function toJSON(message) {
    var obj = {};
    message.storyType !== undefined && (obj.storyType = storyTypeToJSON(message.storyType));

    if (message.snapList) {
      obj.snapList = message.snapList.map(function (e) {
        return e ? PlayerSnap.toJSON(e) : undefined;
      });
    } else {
      obj.snapList = [];
    }

    message.storyId !== undefined && (obj.storyId = message.storyId ? _wrappers.StringWrapper.toJSON(message.storyId) : undefined);
    message.storyTitle !== undefined && (obj.storyTitle = message.storyTitle ? _wrappers.StringWrapper.toJSON(message.storyTitle) : undefined);
    message.thumbnailUrl !== undefined && (obj.thumbnailUrl = message.thumbnailUrl ? _wrappers.StringWrapper.toJSON(message.thumbnailUrl) : undefined);
    message.storySubtitle !== undefined && (obj.storySubtitle = message.storySubtitle ? _wrappers.StringWrapper.toJSON(message.storySubtitle) : undefined);
    message.storyShareId !== undefined && (obj.storyShareId = message.storyShareId ? _wrappers.StringWrapper.toJSON(message.storyShareId) : undefined);
    message.canonicalUrlSuffix !== undefined && (obj.canonicalUrlSuffix = message.canonicalUrlSuffix ? _wrappers.StringWrapper.toJSON(message.canonicalUrlSuffix) : undefined);
    message.emoji !== undefined && (obj.emoji = message.emoji ? _wrappers.StringWrapper.toJSON(message.emoji) : undefined);
    message.storyTapId !== undefined && (obj.storyTapId = message.storyTapId);
    return obj;
  },
  fromPartial: function fromPartial(object) {
    var _object$storyType, _object$snapList, _object$storyTapId;

    var message = createBasePlayerStory();
    message.storyType = (_object$storyType = object.storyType) !== null && _object$storyType !== void 0 ? _object$storyType : 0;
    message.snapList = ((_object$snapList = object.snapList) === null || _object$snapList === void 0 ? void 0 : _object$snapList.map(function (e) {
      return PlayerSnap.fromPartial(e);
    })) || [];
    message.storyId = object.storyId !== undefined && object.storyId !== null ? _wrappers.StringWrapper.fromPartial(object.storyId) : undefined;
    message.storyTitle = object.storyTitle !== undefined && object.storyTitle !== null ? _wrappers.StringWrapper.fromPartial(object.storyTitle) : undefined;
    message.thumbnailUrl = object.thumbnailUrl !== undefined && object.thumbnailUrl !== null ? _wrappers.StringWrapper.fromPartial(object.thumbnailUrl) : undefined;
    message.storySubtitle = object.storySubtitle !== undefined && object.storySubtitle !== null ? _wrappers.StringWrapper.fromPartial(object.storySubtitle) : undefined;
    message.storyShareId = object.storyShareId !== undefined && object.storyShareId !== null ? _wrappers.StringWrapper.fromPartial(object.storyShareId) : undefined;
    message.canonicalUrlSuffix = object.canonicalUrlSuffix !== undefined && object.canonicalUrlSuffix !== null ? _wrappers.StringWrapper.fromPartial(object.canonicalUrlSuffix) : undefined;
    message.emoji = object.emoji !== undefined && object.emoji !== null ? _wrappers.StringWrapper.fromPartial(object.emoji) : undefined;
    message.storyTapId = (_object$storyTapId = object.storyTapId) !== null && _object$storyTapId !== void 0 ? _object$storyTapId : "0";
    return message;
  }
};
exports.PlayerStory = PlayerStory;

function longToString(_long) {
  return _long.toString();
}

if (_minimal["default"].util.Long !== _long2["default"]) {
  _minimal["default"].util.Long = _long2["default"];

  _minimal["default"].configure();
}

function isSet(value) {
  return value !== null && value !== undefined;
}